import React from 'react';
import AppDemo from './AppDemo';

export default function FeatureShowcase() {
  return <section id="experience" className="dl-features">
    <div className="dl-section-heading dl-reveal">
      <div className="dl-section-code">01 / ODKRYJ VROOM</div>
      <h2>Mniej opowiadania.<br /><em>Więcej odkrywania.</em></h2>
      <p>Zobacz VROOM w ruchu. Przełączaj widoki lub pozwól, żeby demo poprowadziło Cię dalej.</p>
    </div>
    <AppDemo />
  </section>;
}
